import http from '@/utils/http';
import i18n from '@/main';

export default {
    findEstados(lockScreen = true) {
        return http.get({
            url: `/estados`,
            lockMessage: i18n.t('mensagens.sistema.aguardeBuscandoEstados'),
            lockScreen
        });
    },

    findMunicipios(estado, lockScreen = true) {
        return http.get({
            url: `/estados/${estado}/municipios`,
            lockMessage: i18n.t('mensagens.sistema.aguardeBuscandoDadosDeMunicipio'),
            lockScreen
        });
    },

    findNivel0(lockScreen = false) {
        return http.get({
            url: `/localidades/nivel0`,
            lockScreen
        });
    },

    findNivel1(idNivel0, lockScreen = true) {
        return http.get({
            url: `/localidades/${idNivel0}/nivel1`,
            lockMessage: i18n.t('mensagens.sistema.aguardeBuscandoEstados'),
            lockScreen
        });
    },

    findNivel2(idNivel1, lockScreen = true) {
        return http.get({
            url: `/localidades/${idNivel1}/nivel2`,
            lockMessage: i18n.t('mensagens.sistema.aguardeBuscandoDadosDeMunicipio'),
            lockScreen
        });
    },

    findLocalizacaoPorGeometria(wkt, gson, lockScreen = true) {
        return http.post({
            url: `/localidades/porGeometria`,
            data: {wkt: wkt, geojson: gson},
            lockScreen
        });
    },

    findLocalizacaoPorId(id, lockScreen = true) {
        return http.get({
            url: `/localidades/${id}/geometria-boundary/`,
            lockScreen
        });
    }
};
